<script setup lang="ts">
const props = defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits<{
  (e: 'update:isOpen', value: boolean): void
}>()

const isOpen = computed({
  get () {
    return props.isOpen
  },
  set (value) {
    emit('update:isOpen', value)
  }
})
</script>

<template>
  <Modal v-model:is-open="isOpen" submit-label="Se déconnecter" cancel-label="Rester connecté" @mousemove="$event.stopPropagation()" @submit-handler="useLogout()">
    <template #header>
      <h1>Déconnexion inactivité</h1>
    </template>
    <p class="text-sm">
      Vous serez déconnecté en raison de l'absence d'activité détectée.
    </p>
  </Modal>
</template>
